// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-panel {
  background: #fff;
}

.test-detail-section {
  border: 1px solid #e3e8ef;
  border-radius: 4px;
  padding: 0.65rem;
}

.test-detail-title {
  margin: 0 0 0.55rem;
  font-size: 0.85rem;
  font-weight: 700;
  color: #3f4954;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.custom-group-label {
  margin: 0.5rem 0 0.35rem;
  font-size: 0.78rem;
  font-weight: 700;
  color: #6b7a8d;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.custom-group-label.output-label {
  margin-top: 0.85rem;
}

.custom-fields {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 0.65rem 1rem;
}

.custom-table-section {
  display: grid;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

.custom-spreadsheet-section {
  display: grid;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  min-width: 0;
}

.custom-spreadsheet-grid {
  display: grid;
  grid-template-columns: repeat(var(--spreadsheet-columns), minmax(8rem, 1fr));
  grid-auto-rows: minmax(3.1rem, auto);
  min-width: 0;
  overflow-x: auto;
  border: 1px solid #dfe5ec;
  background: #fff;
}

.custom-spreadsheet-cell {
  display: flex;
  align-items: center;
  min-width: 0;
  padding: 0.4rem;
  border-right: 1px solid #e4e9ef;
  border-bottom: 1px solid #e4e9ef;
}
.custom-spreadsheet-cell.has-definition {
  background: #fff;
}

.custom-spreadsheet-label {
  width: 100%;
  margin: 0;
  color: #3f4954;
  font-size: 0.85rem;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.custom-spreadsheet-input {
  width: 100%;
  min-width: 0;
}

.table-scroll {
  overflow-x: auto;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 520px;
}
.custom-table th,
.custom-table td {
  border: 1px solid #e4e9ef;
  padding: 0.45rem;
  vertical-align: top;
  text-align: left;
}
.custom-table thead th {
  background: #f6f8fb;
  font-size: 0.8rem;
  font-weight: 700;
  color: #3f4954;
}
.custom-table .row-head {
  width: 3rem;
  white-space: nowrap;
  background: #f6f8fb;
}

.table-key {
  margin-top: 0.2rem;
  font-size: 0.72rem;
  color: #8a97a3;
  font-weight: 500;
}

.test-detail-field {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.test-detail-label {
  margin: 0;
  font-size: 0.85rem;
  color: #555;
  font-weight: 600;
}

.output-field {
  background-color: #f5f7fa;
  color: #4a5568;
  cursor: default;
  border-color: #d1d9e0;
}

.formula-hint {
  font-size: 0.75rem;
  color: #9aa5b4;
  font-style: italic;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/job-request-overview/test-details/job-request-test-custom-detail.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AACF;;AAEA;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AACF;AACE;EACE,mBAAA;AACJ;;AAGA;EACE,aAAA;EACA,4DAAA;EACA,iBAAA;AAAF;;AAGA;EACE,aAAA;EACA,WAAA;EACA,sBAAA;AAAF;;AAGA;EACE,aAAA;EACA,WAAA;EACA,sBAAA;EACA,YAAA;AAAF;;AAGA;EACE,aAAA;EACA,4EAAA;EACA,oCAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,+BAAA;EACA,gCAAA;AAAF;AAEE;EACE,gBAAA;AAAJ;;AAIA;EACE,WAAA;EACA,SAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;AADF;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,WAAA;EACA,yBAAA;EACA,gBAAA;AADF;AAGE;;EAEE,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AADJ;AAIE;EACE,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAFJ;AAKE;EACE,WAAA;EACA,mBAAA;EACA,mBAAA;AAHJ;;AAOA;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AAJF;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAJF;;AAOA;EACE,SAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AAJF;;AAOA;EACE,yBAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAJF","sourcesContent":[".custom-panel {\n  background: #fff;\n}\n\n.test-detail-section {\n  border: 1px solid #e3e8ef;\n  border-radius: 4px;\n  padding: 0.65rem;\n}\n\n.test-detail-title {\n  margin: 0 0 0.55rem;\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: #3f4954;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.custom-group-label {\n  margin: 0.5rem 0 0.35rem;\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: #6b7a8d;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n\n  &.output-label {\n    margin-top: 0.85rem;\n  }\n}\n\n.custom-fields {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  gap: 0.65rem 1rem;\n}\n\n.custom-table-section {\n  display: grid;\n  gap: 0.5rem;\n  margin-bottom: 0.75rem;\n}\n\n.custom-spreadsheet-section {\n  display: grid;\n  gap: 0.5rem;\n  margin-bottom: 0.75rem;\n  min-width: 0;\n}\n\n.custom-spreadsheet-grid {\n  display: grid;\n  grid-template-columns: repeat(var(--spreadsheet-columns), minmax(8rem, 1fr));\n  grid-auto-rows: minmax(3.1rem, auto);\n  min-width: 0;\n  overflow-x: auto;\n  border: 1px solid #dfe5ec;\n  background: #fff;\n}\n\n.custom-spreadsheet-cell {\n  display: flex;\n  align-items: center;\n  min-width: 0;\n  padding: 0.4rem;\n  border-right: 1px solid #e4e9ef;\n  border-bottom: 1px solid #e4e9ef;\n\n  &.has-definition {\n    background: #fff;\n  }\n}\n\n.custom-spreadsheet-label {\n  width: 100%;\n  margin: 0;\n  color: #3f4954;\n  font-size: 0.85rem;\n  font-weight: 600;\n  overflow-wrap: anywhere;\n}\n\n.custom-spreadsheet-input {\n  width: 100%;\n  min-width: 0;\n}\n\n.table-scroll {\n  overflow-x: auto;\n}\n\n.custom-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 520px;\n\n  th,\n  td {\n    border: 1px solid #e4e9ef;\n    padding: 0.45rem;\n    vertical-align: top;\n    text-align: left;\n  }\n\n  thead th {\n    background: #f6f8fb;\n    font-size: 0.8rem;\n    font-weight: 700;\n    color: #3f4954;\n  }\n\n  .row-head {\n    width: 3rem;\n    white-space: nowrap;\n    background: #f6f8fb;\n  }\n}\n\n.table-key {\n  margin-top: 0.2rem;\n  font-size: 0.72rem;\n  color: #8a97a3;\n  font-weight: 500;\n}\n\n.test-detail-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.test-detail-label {\n  margin: 0;\n  font-size: 0.85rem;\n  color: #555;\n  font-weight: 600;\n}\n\n.output-field {\n  background-color: #f5f7fa;\n  color: #4a5568;\n  cursor: default;\n  border-color: #d1d9e0;\n}\n\n.formula-hint {\n  font-size: 0.75rem;\n  color: #9aa5b4;\n  font-style: italic;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
